import RequestService from "@/configurations/AxiosConfig";
import { ISendMailPayrollSlipRequest } from "@/types/type";

const endpoints = {
  payrollSlips: 'payroll-slips',
  payrollSlipsByCompany: 'payroll-slips/byCompanyId',
  sendMail: 'payroll-slips/sendMail',
  remove: 'payroll-slips/remove',
};

const PayrollSlipsService = {
  getAllPayrollSlips: () => RequestService.get(endpoints.payrollSlips),
  getPayrollSlipsByCompanyId: (companyId: string | number) => RequestService.get(`${endpoints.payrollSlipsByCompany}/${companyId}`),
  createPayrollSlip: (data: FormData ) => RequestService.post(endpoints.payrollSlips, data),
  sendMailPayrollSlips: async (data: ISendMailPayrollSlipRequest) => RequestService.post(endpoints.sendMail, data),
  removePayrollSlip: async (id: string | number) => RequestService.patch(`${endpoints.remove}/${id}`),
};

export default PayrollSlipsService;
